import apiUrlHelper from './ApiUrlHelper.js';
import AuthService from '@/services/AuthService.js';

// Shared HTTP helpers for the services. There is one place that knows how to
// attach the candidate bearer token, so every service authenticates the same way.

// Merges the candidate bearer token into the given headers when the user is
// signed in. Endpoints that allow anonymous access can use this directly — the
// token is simply omitted when there is no session.
export async function authHeaders(base = {}) {
  if (!AuthService.isAuthenticated()) {
    return base;
  }

  const token = await AuthService.getToken();
  return token ? { ...base, Authorization: `Bearer ${token}` } : base;
}

// fetch() against the current company API with the auth headers attached.
export async function authorizedFetch(path, options = {}) {
  const headers = await authHeaders(options.headers || {});

  return fetch(`${apiUrlHelper.apiUrl()}${path}`, {
    ...options,
    headers
  });
}
